import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import {  ServiceResponseModule } from '@sdbn/common';
import { EditTransportComponent } from './component/edit-transport.component';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from '../transport-options-panel/transport-options-panel.module';
import { TransportDetailsModule } from '../../common/components/transport-details/transport-details.module';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';


@NgModule({
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportDetailsModule,
    TransportOptionsPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    MatTabsModule,
    MatCheckboxModule
  ],
  declarations: [
    EditTransportComponent],
  exports: []
})
export class EditTransportModule { }
